import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModalModule, NgbModule, NgbTabsetModule } from '@cmps/ng-bootstrap';
import { NgChartModule } from '@cmps/ng-chart';
import { CmpsIconModule } from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';
import { CmpsRouterModule } from '../route.module';
import { Widgets } from '../widget/widget.model';
import { CmpsWidgetModule } from '../widget/widget.module';

import { CaoDetailsWidgetComponent } from './cao-details.widget.component';
import { CaoMetricCyclePerformanceWidgetComponent } from './cao-metric-cycle-performance.widget.component';
import { CaoOpportunityWidgetComponent } from './cao-opportunity.widget.component';
import { CurrentPerformanceChartWidgetComponent } from './current-performance-chart.widget.component';
import { DualChartPerformanceComparisonWidgetComponent } from './dual-chart-performance-comparison.widget.component';
import { ExternalContentWidgetComponent } from './external-content.widget.component';
import { TranslationIdMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';
import { ManagementEffectivenessWidgetComponent } from './management-effectiveness.widget.component';
import { MbnaComplianceDetailsWidgetComponent } from './mbna-compliance-details.widget.component';
import { MbnaComplianceWidgetComponent } from './mbna-compliance.widget.component';
import { MbnaDualChartPerformanceComparisonWidgetComponent } from './mbna-dual-chart-performance-comparison.widget.component';
import { MetricDataListWidgetComponent } from './metric-data-list.widget.component';
import { MetricFocusWidgetComponent } from './metric-focus.widget.component';
import { Mi2DetailsWidgetComponent } from './mi2-details.widget.component';
import { MyPerformanceVsPeersWidgetComponent } from './my-performance-vs-peers.widget.component';
import { PersonalCoachingWidgetComponent } from './personal-coaching.widget.component';
import { PersonalScorecardChartWidgetComponent } from './personal-scorecard-chart.widget.component';
import { PersonalScorecardListWidgetComponent } from './personal-scorecard-list.widget.component';
import { PieBarWidgetComponent } from './pie-bar.widget.component';
import { PillarPerformanceWidgetComponent } from './pillar-performance.widget.component';
import { ScorecardListWidgetComponent } from './scorecard-list.widget.component';
import { TdbfgComplianceDetailsWidgetComponent } from './tdbfg-compliance-details.widget.component';
import { TdbfgComplianceWidgetComponent } from './tdbfg-compliance.widget.component';
import { TeamCoachingDetailsWidgetComponent } from './team-coaching-details.widget.component';
import { TeamCoachingWidgetComponent } from './team-coaching.widget.component';
import { TeamDistributionByPillarWidgetComponent } from './team-distribution-by-pillar.widget.component';
import { TeamManagementEffectivenessWidgetComponent } from './team-management-effectiveness.widget.component';
import { TeamScorecardChartWidgetComponent } from './team-scorecard-chart.widget.component';
import { TopPerformanceOpportunityWidgetComponent } from './top-performance-opportunity.widget.component';

const ModuleWidgets: Widgets = [
    {
        typeId: 1,
        component: MetricFocusWidgetComponent,
        isDateRangeAware: true,
    },
    { typeId: 2, component: TopPerformanceOpportunityWidgetComponent },
    { typeId: 3, component: MyPerformanceVsPeersWidgetComponent },
    { typeId: 4, component: ExternalContentWidgetComponent },
    { typeId: 5, component: PersonalScorecardListWidgetComponent },
    { typeId: 6, component: PersonalScorecardChartWidgetComponent },
    { typeId: 7, component: TeamScorecardChartWidgetComponent },
    { typeId: 8, component: TeamManagementEffectivenessWidgetComponent },
    { typeId: 9, component: ManagementEffectivenessWidgetComponent },
    {
        typeId: 10,
        component: MetricDataListWidgetComponent,
        isDateRangeAware: true,
    },
    {
        typeId: 11,
        component: DualChartPerformanceComparisonWidgetComponent,
        isDateRangeAware: true,
    },
    { typeId: 12, component: PersonalCoachingWidgetComponent },
    { typeId: 13, component: TeamCoachingWidgetComponent },
    { typeId: 14, component: CurrentPerformanceChartWidgetComponent },
    { typeId: 15, component: TeamDistributionByPillarWidgetComponent },
    {
        typeId: 24,
        component: MbnaDualChartPerformanceComparisonWidgetComponent,
    },
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        NgbModalModule,
        NgbTabsetModule,
        NgChartModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsCommonModule,
        CmpsRouterModule,
        CmpsWidgetModule.forChild(ModuleWidgets),
        CmpsIconModule,
    ],
    declarations: [
        CurrentPerformanceChartWidgetComponent,
        PieBarWidgetComponent,
        DualChartPerformanceComparisonWidgetComponent,
        TopPerformanceOpportunityWidgetComponent,
        TeamDistributionByPillarWidgetComponent,
        MetricFocusWidgetComponent,
        MetricDataListWidgetComponent,
        TeamScorecardChartWidgetComponent,
        PersonalScorecardListWidgetComponent,
        PersonalScorecardChartWidgetComponent,
        PersonalCoachingWidgetComponent,
        TeamCoachingWidgetComponent,
        ManagementEffectivenessWidgetComponent,
        TeamManagementEffectivenessWidgetComponent,
        MyPerformanceVsPeersWidgetComponent,
        CaoOpportunityWidgetComponent,
        CaoDetailsWidgetComponent,
        CaoMetricCyclePerformanceWidgetComponent,
        Mi2DetailsWidgetComponent,
        TeamCoachingDetailsWidgetComponent,
        ScorecardListWidgetComponent,
        PillarPerformanceWidgetComponent,
        TdbfgComplianceWidgetComponent,
        TdbfgComplianceDetailsWidgetComponent,
        MbnaDualChartPerformanceComparisonWidgetComponent,
        MbnaComplianceWidgetComponent,
        MbnaComplianceDetailsWidgetComponent,
        ExternalContentWidgetComponent,
    ],
})
export class CmpsLegacyWidgetModule {
    static forRoot(): ModuleWithProviders<CmpsLegacyWidgetModule> {
        return {
            ngModule: CmpsLegacyWidgetModule,
            providers: [LegacyWidgetService],
        };
    }
}
